import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { UserContestService } from 'src/app/services/usercontest.service';
import * as moment from 'moment';
import { ContestService } from 'src/app/services/contest.service';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';
import { RoleService } from 'src/app/services/role.service';
import { HttpClient } from '@angular/common/http';
import { maxYearFunction } from 'src/app/_helpers/utility';
import { HeaderComponent } from '../../header/header.component';
import { CityService } from 'src/app/manage/city/service/city.service';
import { UserService } from 'src/app/services/user.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { WalletpaymentService } from 'src/app/services/walletPayments.service';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { Table } from 'primeng/table';
import { interval } from 'rxjs';
@Component({
  selector: 'app-my-contest',
  templateUrl: './my-contest.component.html',
  styleUrls: ['./my-contest.component.scss'],
  providers: [HeaderComponent, MessageService, ConfirmationService],
})
export class MyContestComponent implements OnInit {
  items: MenuItem[];
  public options;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  public contestList: any[] = [];
  public checkedBoxes: any[] = [];
  public attemptedQuestions: any[] = [];
  public resultList: any[] = [];
  public currentIndex: number = 0;
  public selectedOption: any = null;
  public currentQuestion;
  public answerString;
  public showSubmitButton: boolean = false;
  public downloadFlg: boolean = false;
  public showResult: boolean = false;
  public totalMarks: number = 0;
  public questionMarksTotal: number = 0;
  public rejoincontestList: any[] = [];
  public totalRecordsForRejoin = 0;
  dcalvalue: any;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  @ViewChild('prevButton') prevButton: ElementRef;
  @ViewChild('nextButton') nextButton: ElementRef;
  lazyLoadEvent: LazyLoadEvent;
  searchby: any;
  startDate: any;
  endDate: any;
  public pagination = environment.pagination;
  public mode = "";
  loggedInUser: any;
  isLoggedIn: boolean = false;
  loginRegisterModal: boolean = false;
  showMobileLoginOtpForm: boolean = false;
  signUpForm: FormGroup;
  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  balanceForm: FormGroup;
  addCashForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  showGenderError;
  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public successMessage;
  public activeIndex: number = 0;
  public showCategoryError: boolean = false;
  public letsPlayButtonDisabled: boolean = false;
  public addCoinModal: boolean = false;
  public totalAvailableCash;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public userCategories: any[] = [];
  public countrylist: any[] = [];
  public selectedCategory = undefined;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  public selectedType = undefined;
  public tplCoin: Number;
  public tplCash: Number;
  public showBalanceModal: boolean = false;
  public showBalanceCoinsError: boolean = false;
  public showBalanceCashError: boolean = false;
  public showAddCashModal: boolean = false;
  public tplCashCoinArr: any = [];
  public poolCash;
  public poolCoins;
  public cashFormSubmitted: boolean = false;
  public balanceFormSubmitted: boolean = false;
  public cashBalance: number = 0;
  public coinBalance: number = 0;
  public showCashBalance: boolean = false;
  public showCoinBalance: boolean = false;
  public showCashError: boolean = false;
  public showContestDetailSection: boolean = false;
  public userId;
  public contestId: any;
  public showPaymentSelectionError: boolean = false;
  public contest;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public showDontShowAgainError: boolean = false;
  showThankyouModal: boolean;
  totalCash: any;
  totalCoins: any;
  public addCoinForm: FormGroup;
  public coinSubmitted;
  @ViewChild("dt", { static: false }) public dt: Table;
  fstartDate: any;
  fendDate: any;
  intervalTime;
  constructor(private questionService: QuestionService,
    private userContestService: UserContestService,
    private contestService: ContestService,
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private http: HttpClient,
    private headerComponent: HeaderComponent,
    private cityService: CityService,
    private userService: UserService,
    private countryService: CountryService,
    private stateService: StateService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private winRef: WindowRefService,
    private walletPaymentService: WalletpaymentService,
    private userWalletService: UserWalletService
  ) { }

  ngOnDestroy(): void {
    clearInterval(this.intervalTime);
  }
  async ngAfterViewInit(): Promise<void> {
    this.intervalTime = interval(30000).subscribe(
      (val) => {
        this.onClickRefresh();
      });
    //await this.getContestDetails()
    
    
    // if (this.contestDetails?.tournamentMatchStatus !== 'notstarted' && this.contestDetails?.tournamentMatchStatus !== undefined && this.contestDetails?.tournamentMatchStatus !== 'finished') {
    //   this.intervalTime = setInterval(async() => {
    //     // await this.getContestDetails()
    //     this.onClickRefresh();
    //   }, 1000);
    // }
  }
  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
      //this.getUserContest();
    }
      await this.loadContest(this.lazyLoadEvent, 'on-load');

  }

  async loadContest(event: LazyLoadEvent, mode) {

    this.lazyLoadEvent = event;

    if (this.fstartDate !== undefined && this.fendDate !== undefined) {
      this.errorMessage = '';
    } else {
      this.errorMessage = '';
      //return;
    }

    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "filterByDisable=false&filterByStatus=true&filterByisContestRegistrationComplete=true&filterByUserId=" + this.userId;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }

      if (event.filters != undefined && event.filters["matchDate"] != undefined) {
        const date = moment(event.filters["matchDate"].value).format("YYYY-MM-DD");
        params += "&filterByMatchDate=" + date;

      }
      if (event.filters != undefined && event.filters["poolPrize"] != undefined) {
        params += "&filterByPoolPrize=" + event.filters["poolPrize"].value;
      }
      if (event.filters != undefined && event.filters["entryFee"] != undefined) {
        params += "&filterByEntryFee=" + event.filters["entryFee"].value;
      }
      if (event.filters != undefined && event.filters["totalPoints"] != undefined) {
        params += "&filterByTotalPoints=" + event.filters["totalPoints"].value;
      }
      if (event.filters != undefined && event.filters["prizeWon"] != undefined) {
        params += "&filterByPrizeWon=" + event.filters["prizeWon"].value;
      }
      if (event.filters != undefined && event.filters["tournamentName"] != undefined) {
        params += "&filterByTournamentName=" + event.filters["tournamentName"].value;
      }
      if (event.filters != undefined && event.filters["playerName"] != undefined) {
        params += "&filterByPlayerName=" + event.filters["playerName"].value;
      }
      if (
        this.fstartDate != undefined &&
        this.fendDate != undefined
      ) {
        params +=
          "&filterByStartDate=" + moment(this.fstartDate).format("YYYY-MM-DD");
        params += "&filterByEndDate=" + moment(this.fendDate).format("YYYY-MM-DD");

      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userContestService.getUserContestList(query).subscribe(
      data => {
        this.loading = false;
        this.contestList = data.data?.items;
        this.totalRecords = data.data?.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }


  async onClickMatchStats(matchId) {
    this.router.navigate(['contest-match-stats/' + matchId]);
  }
  clear() {
    this.dcalvalue = null;
    this.endDate = null;
    this.startDate = null;
    this.searchby = '';
    this.fstartDate = null;
    this.fendDate = null;
    this.dt.filter('', 'tournamentName', 'contains');
    this.dt.filter('', 'playerName', 'contains');
    this.dt.filter('', 'entryFee', 'contains');
    this.dt.filter('', 'prizeWon', 'contains');
    this.dt.filter('', 'poolPrize', 'contains');
    this.dt.filter('', 'matchDate', 'contains');
    this.dt.filter('', 'totalPoints', 'contains');
    this.loadContest(this.lazyLoadEvent,'on-load');
  }

  onDateFilteredSelect(event) {
    console.log(event);
  }

  onClickRefresh() {
    if(this.contestList.length >  0){
      this.contestList.forEach((contest)=>{
        if (contest.matchStatus !== 'notstarted' && contest.matchStatus !== undefined && contest.matchStatus !== 'finished'){
          this.loadContest(this.lazyLoadEvent, 'on-refresh');
        }
      })
    }
   }

}
